import {deferToIdle} from '../utils/deferToIdle.js';
import {ensureTurnstileLoaded, renderTurnstile} from '../modules/turnstile.js';
import {Notification} from '../modules/notification.js';
import {t} from '../localization/translate.js';

/**
 * Loads the footer CAPTCHA when the email input receives focus.
 */
class FooterNewsletterForm {
    static selector = {
        form: '[data-footer-newsletter-form]',
        emailInput: 'input[type="email"]',
    };

    /**
     * @param {HTMLFormElement} formElement
     */
    constructor(formElement) {
        this.form = formElement;

        /** @type {HTMLInputElement|null} */
        this.emailInput = this.form.querySelector(FooterNewsletterForm.selector.emailInput);
        if (this.emailInput) {
            this.emailInput.addEventListener('focus', this.#loadTurnstile.bind(this), {once: true});
        }
    }

    /** Lazy-loads Turnstile when the user focuses the email input. */
    #loadTurnstile() {
        const turnstileElement = this.form.querySelector('.cf-turnstile');
        if (turnstileElement instanceof HTMLElement) {
            ensureTurnstileLoaded()
                .then(() => renderTurnstile(turnstileElement))
                .catch((error) => {
                    Notification.error(t('Captcha failed to load: :reason', {reason: error.message}));
                });
        }
    }

    /**
     * Initializes the newsletter form behavior.
     */
    static init() {
        const forms = document.querySelectorAll(FooterNewsletterForm.selector.form);
        forms.forEach(form => new FooterNewsletterForm(/** @type {HTMLFormElement} */ (form)));
    }
}

// Initialize when the DOM is ready, deferred to idle time (always below fold)
document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => deferToIdle(FooterNewsletterForm.init))
    : deferToIdle(FooterNewsletterForm.init);
